import React, { useState } from 'react'

import { useMutation } from 'react-query'
import { toast } from 'react-toastify'

import { postCompanies } from '../../../../MyApi/hr/companies'

import PageHeader from '../../../../Components/UI/PageHeader'
import AddCompanies from '../../../../Components/sb/companies/companiesStore/AddCompanies'


const CompaniesStore = () => {
const [companyName ,setComapnyName]= useState("")
const [address ,setAddress] =useState("")
const [states ,setStates]=useState("")
const [slug , setSlug] =useState("")
const [website ,setWebsite]= useState("")
const [email,setEmail] =useState("")
const [mobile ,setMobile]=useState("")
const [comapnyFiledId , setCompanyFiledId]= useState("")
const [currencyId,setCurrencyId]=useState("")
const [countryId ,setCountryId]= useState("")
const [active,setActive] =useState(1)
const [sb_package_id ,setPackageId ]= useState("")
 const mutation = useMutation("postComapnies" , (postData)=>postCompanies(postData) ,{
    onSuccess:(data)=>{
        toast.success(`${data.message}`)
        setComapnyName("")
        setAddress("")
        setStates("")
        setSlug("")
        setEmail("")
        setWebsite("")
        setMobile("")
        setCompanyFiledId("")
        setCurrencyId("")
        setCountryId("")
      
    },
    onError :(error)=>{
        toast.error(`${error.response.data.message}`)
    }
 })

 const handlePostRequest =()=>{
    mutation.mutate({
        name:companyName,     
        sb_country_id:countryId,
        address,
        states,
        slug,
        website,
        email,
        mobile,
        active,
        comapnyFiledId,
        currencyId,
        sb_country_id:+countryId,
        sb_company_field_id:+comapnyFiledId,
        sb_currency_id : +currencyId ,
        sb_package_id
    })
 }
 const isDisabled= ()=>{
    return !(companyName && countryId && address &&  states &&  slug &&  email &&  mobile && comapnyFiledId && currencyId  )
 }
  return ( 

    <div>
        <PageHeader title="Add company"  showBack={true} saveButton={true} isdisbled={isDisabled} handlePostRequest={handlePostRequest} />
        <AddCompanies setPackageId={setPackageId} setActive={setActive} active={active} address={address}      states={states} slug={slug} website={website} email={email} mobile={mobile} comapnyFiledId={comapnyFiledId} currencyId={currencyId}  setComapnyName={setComapnyName}  setAddress={setAddress} setStates={setStates} setSlug={setSlug} setWebsite={setWebsite} setEmail={setEmail} setMobile={setMobile} setCompanyFiledId={setCompanyFiledId} setCountryId={setCountryId}  setCurrencyId={setCurrencyId}/>
    </div>
  )
}

export default CompaniesStore